/*
* TeamInfoTableSection.jsx
* Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
* All rights reserved.
*/
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Divider, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import PropTypes from "prop-types";

export default function TeamTableSection({
  employee,
  username,
  handleDeleteTeamPopup,
  handleEditTeamPopup,
  loggedInUserRole,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleVertIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditTeam = (editTeamData) => {
    setAnchorEl(null);
    handleEditTeamPopup(editTeamData);
  };

  const handleDeleteTeam = (deleteTeamData) => {
    setAnchorEl(null);
    handleDeleteTeamPopup(deleteTeamData);
  };

  return (
    <tr key={employee.id}>
      <td className="name-text" id="empName">
        {employee.name}
        {username === employee.id && " (You)"}
      </td>
      <td className="email-text" id="empEmail">
        {employee.email}
      </td>
      <td className="email-text" id="role">
        <div className="roleCls">
          <span
            className={
              employee.role === "MANAGER"
                ? "manager-row-width"
                : "member-row-width"
            }
          >
            {employee.role}
          </span>

          {loggedInUserRole === "MANAGER" && (
            <MoreVertIcon
              className="moreVertIconHover"
              onClick={handleVertIconClick}
              id="action-button"
              aria-controls={open ? "delete-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            />
          )}
        </div>
        <Menu
          sx={{
            "& .MuiList-root.MuiMenu-list": {
              padding: "8px",
              "& .MuiButtonBase-root.MuiMenuItem-root": {
                borderRadius: "4px",
              },
            },
          }}
          id="delete-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: {
              "aria-labelledby": "action-button",
            },
          }}
        >
          <MenuItem onClick={() => handleEditTeam(employee)}>
            <div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4863 5.73699L10.2307 2.51507L11.3031 1.4411C11.5968 1.14703 11.9574 1 12.3851 1C12.8128 1 13.1735 1.14703 13.4671 1.4411L14.5396 2.51507C14.8332 2.80913 14.9864 3.16393 14.9992 3.57945C15.012 3.99498 14.8715 4.34977 14.5779 4.64384L13.4863 5.73699ZM12.3755 6.86849L4.25563 15H1V11.7397L9.11992 3.60822L12.3755 6.86849Z"
                  fill="#121415"
                  fillOpacity="0.6"
                />
              </svg>
              &nbsp;<span style={{ color: "#2A2C2D" }}>Edit</span>
            </div>
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => handleDeleteTeam(employee)}>
            <div className="deleteAppCls">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.55558 16C3.06669 16 2.64818 15.8259 2.30003 15.4778C1.95188 15.1296 1.7778 14.7111 1.7778 14.2222V2.66667H0.888916V0.888889H5.33336V0H10.6667V0.888889H15.1111V2.66667H14.2222V14.2222C14.2222 14.7111 14.0482 15.1296 13.7 15.4778C13.3519 15.8259 12.9334 16 12.4445 16H3.55558ZM12.4445 2.66667H3.55558V14.2222H12.4445V2.66667ZM5.33336 12.4444H7.11114V4.44444H5.33336V12.4444ZM8.88892 12.4444H10.6667V4.44444H8.88892V12.4444Z"
                  fill="#B50B00"
                />
              </svg>
              &nbsp;Delete Member
            </div>
          </MenuItem>
        </Menu>
      </td>
    </tr>
  );
}

TeamTableSection.propTypes = {
  employee: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
  username: PropTypes.string.isRequired,
  handleDeleteTeamPopup: PropTypes.func.isRequired,
  handleEditTeamPopup: PropTypes.func.isRequired,
  loggedInUserRole: PropTypes.string.isRequired,
};
